// 特惠寄--商家寄件
import request from '@/utils/request';
// 导入文件上传--无发件人（导入接口耗时较长，超时时间 120s）
export function uploadImportFileApi(data) {
  return request({
    baseURL: '/khgj-file/',
    url: '/positiveOrderImport/uploadOzonfile',
    method: 'post',
    data,
    timeout: 240000
  });
}
// 导入文件上传--有发件人（导入接口耗时较长，超时时间 120s）
export function uploadSendAndReceiveImportFileApi(data) {
  return request({
    baseURL: '/khgj-file/',
    url: '/positiveOrderImport/uploadOzonSendAndReceivefile',
    method: 'post',
    data,
    timeout: 240000
  });
}
// 查询订单列表
export function queryOZonMerchantAccountApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonMerchant/info',
    method: 'post',
    data
  });
}
// 创建订单
export function saveOZonMerchantAccountApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonMerchant/save',
    method: 'post',
    data
  });
}
// 创建订单
export function unbindOZonMerchantAccountApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonMerchant/unbind',
    method: 'post',
    data
  });
}
// 取消订单
export function changeOZonMerchantAccountApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonMerchant/change',
    method: 'post',
    data
  });
}
// 查询订单列表
export function queryOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/queryOrder',
    method: 'post',
    data
  });
}
// 创建订单--单条
export function createOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/createOrder',
    method: 'post',
    data
  });
}
// 创建订单--批量
export function batchCreateOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/batchCreateOrder',
    method: 'post',
    data
  });
}
// 取消订单
export function cancelOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/cancelOrder',
    method: 'post',
    data
  });
}
// 批量取消订单
export function batchCancelOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/batchCancelOrder',
    method: 'post',
    data
  });
}
// 更新订单
export function changeOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/changeOrderInfo',
    method: 'post',
    data
  });
}
// 合并订单
export function mergeOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/mergeOrder',
    method: 'post',
    data
  });
}
// 打印订单--获取订单详情
export function printOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/printOrder',
    method: 'post',
    data
  });
}
// 导入记录查询 
export function importResultRecordForOZonOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/queryUserImportResult',
    method: 'post',
    data
  });
}
// 获取收件人地址列表
export function getOzonAddressListApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/returnsOzonAddress/queryList',
    method: 'post',
    data
  });
}
// 查询绑定的业务员信息
export function searchSellerBindInfoApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basic/returnsPickup/searchSellerBindInfo',
    method: 'post',
    data
  });
}
// 解绑业务员信息
export function unBindSellerApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basic/returnsPickup/unBindSeller',
    method: 'post',
    data
  });
}
// 绑定的业务员信息
export function bindSellerApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basic/returnsPickup/bindSeller',
    method: 'post',
    data
  });
}
// 订单导出--特惠寄
export function exportOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/oZonOrder/exportOrder',
    method: 'post',
    data
  });
}
